import { useTranslation } from "react-i18next";

/** Returns the active locale string, falling back to the browser locale then a default */
export const useLocale = (): string => {
    const { i18n } = useTranslation();
    return i18n.language || navigator.language || "en-CA";
};
